import { render, staticRenderFns } from "./EditPerDocumentStockSettingsModal.vue?vue&type=template&id=950ec836"
import script from "./EditPerDocumentStockSettingsModal.vue?vue&type=script&lang=ts"
export * from "./EditPerDocumentStockSettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('950ec836')) {
      api.createRecord('950ec836', component.options)
    } else {
      api.reload('950ec836', component.options)
    }
    module.hot.accept("./EditPerDocumentStockSettingsModal.vue?vue&type=template&id=950ec836", function () {
      api.rerender('950ec836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/EditPerDocumentStockSettingsModal.vue"
export default component.exports